/**
 * Created by galweissman on 16/05/2016.
 * Behavior automatically sets video url according to view's miniVideoUrl property (if set)
 * Follow the triggers on intialize method to control different behaviors
 * (e.g. _setUrl(url) updates the video URL on the player)
 * Supports image fallback automatically(!), just trigger _setUrl with an image url
 * Binds automatically on DOM's first relevant video element
 */

import app from 'app';
import Marionette from 'backbone.marionette';

app.namespace.Behavior.GenericVideoPlayer = Marionette.Behavior.extend({
  eventNamespace: '.genericVideoPlayer',

  ui: {
    video: 'video',
    videoProgBarContainer: '.js-video-loading-shutter',
    actionButton: '.js-video-play-button',
    videoProgBar: '.js-video-progress-bar',
    videoPreviewOverlay: '.js-preview-overlay',
    videoErrorOverlay: '.js-overlay-error',
    imageFallback: '.js-image-fallback',
  },

  events: {},

  initialize: function () {
    $(window).on('keydown' + this.eventNamespace, this._onkeydown.bind(this));
    this.view.on('miniVideo:preview:start', this._displayPreviewMessage, this);
    this.view.on('miniVideo:preview:end', this._hidePreviewMessage, this);
    this.view.on('miniVideo:error:show', this._displawErrorMessage, this);
    this.view.on('miniVideo:error:hide', this._hideErrorMessage, this);
    this.view.on('miniVideo:url:set', this._setUrl, this);
    this.failed = false;
    this.canPlay = true;
  },

  onRender: function () {
    const videoComponentsTmpl = app.compileTemplate.$(
      '#mini-video-player-tmpl'
    );
    this.ui.videoContainer.append(videoComponentsTmpl());
    this.view.bindUIElements();
    this.video = this.ui.video.get(0);
    this._initVideoEvents();
  },

  onShow: function () {
    if (this.view.miniVideoUrl) {
      this._setUrl(this.view.miniVideoUrl);
    }
  },

  _displawErrorMessage: function (msg) {
    this.canPlay = false;
    this.ui.videoErrorOverlay.addClass('wt-active').html(msg);
    this._pause();
  },

  _hideErrorMessage: function () {
    this.canPlay = true;
    this.ui.videoErrorOverlay.removeClass('wt-active');
  },

  _displayPreviewMessage: function () {
    this._hideErrorMessage();
    this.canPlay = false;
    this._previewInprogress = true;
    this.ui.videoPreviewOverlay.fadeIn('fast');
    this.failed = true;
    this._pause();
  },

  _hidePreviewMessage: function () {
    this.canPlay = true;
    this._previewInprogress = false;
    this.ui.videoPreviewOverlay.fadeOut('fast');
    this.failed = false;
    this._pause();
  },

  _onkeydown: function (e) {
    if (
      !this.canPlay ||
      this._previewInprogress ||
      $(event.target).is('input') ||
      $(event.target).is('select') ||
      $(event.target).is('textarea') ||
      $(event.target).is('button')
    ) {
      return;
    }
    const key = e.keyCode || e.which;
    switch (key) {
      case $.ui.keyCode.SPACE:
        this._playOrPauseVideo();
        break;
    }
  },

  _setUrl: function (url) {
    this._hidePreviewMessage(); // keep it.
    this._hideErrorMessage(); // keep this one too.

    if (url.match(/[^/]+\.(jpg|png|jpeg|gif)\b/i)) {
      this.ui.imageFallback.find('img').attr('src', url);
      this.ui.imageFallback.show();
      $(this.video).attr('src', '');
    } else {
      this.ui.imageFallback.hide();
      $(this.video).attr('src', url);
    }
  },

  _initVideoEvents: function () {
    this.ui.video.on(
      'pause',
      function () {
        this._animatePlayButton('wt-pause-circle', 'wt-play-circle');
      }.bind(this)
    );
    this.ui.video.on(
      'ended',
      function () {
        this._animatePlayButton('wt-pause-circle', 'wt-play-circle');
      }.bind(this)
    );
    this.ui.video.on(
      'loadeddata',
      function () {
        this.ui.videoProgBarContainer.hide();
        this._animatePlayButton('wt-play-circle', 'wt-pause-circle');
      }.bind(this)
    );
    this.ui.video.on(
      'loadstart',
      function () {
        this.ui.videoProgBarContainer.show();
        this.ui.videoProgBar.css('width', '0%');
        _.delay(
          function () {
            if ($.isElement(this.ui.videoProgBar)) {
              this.ui.videoProgBar.css('width', '100%');
            }
          }.bind(this),
          50
        );
      }.bind(this)
    );
  },

  _animatePlayButton: function (inClass, outClass) {
    const $button = this.ui.actionButton;
    if (!$button || !$button.length || !$.isElement($button)) {
      return;
    }

    $button.one('transitionend', function () {
      $button.removeClass('animated');
      $button.css({
        visibility: 'hidden',
      });
    });
    $button.removeClass(outClass).addClass(inClass);
    $button.css({
      visibility: 'visible',
    });

    _.delay(() => {
      if ($.isElement(this.ui.actionButton)) {
        this.ui.actionButton.addClass('animated');
      }
    }, 10);
  },

  onBeforeDestroy: function () {
    this.ui.video.off();
    $(window).off(this.eventNamespace);
  },

  _playOrPauseVideo: function () {
    if (this.video.paused) {
      this._play();
    } else {
      this._pause();
    }
  },

  _play: function () {
    this._animatePlayButton('wt-play-circle', 'wt-pause-circle');
    this.video.play().catch(() => 0);
  },

  _pause: function () {
    this.video.pause();
  },
});

export default app.namespace.Behavior.GenericVideoPlayer;
